import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { QrCode, Loader2 } from "lucide-react";
import { selectCls } from "@/components/erp/ErpUi";

const TYPES = [["cpf", "CPF"], ["cnpj", "CNPJ"], ["email", "E-mail"], ["telefone", "Telefone"], ["aleatoria", "Chave aleatória"]];
const cls = "mt-1 bg-zinc-900 border-zinc-800";

export function PixSettingsCard({ shop, onSaved }) {
  const p = shop?.pix || {};
  const [f, setF] = useState({ key_type: p.key_type || "cnpj", key: p.key || "", name: p.name || shop?.name || "", city: p.city || "", doc: p.doc || "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF((x) => ({ ...x, [k]: e.target.value }));
  const save = async () => {
    setBusy(true);
    try { await api.put("/shop-settings/pix", f); toast.success(f.key.trim() ? "Pix salvo" : "Pix removido"); onSaved?.(); }
    catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  return (
    <section data-testid="pix-settings-card" className="rounded-2xl border border-card2-border bg-card2 p-5 space-y-3">
      <h2 className="flex items-center gap-2 font-display text-lg font-bold uppercase text-zinc-100"><QrCode className="h-4 w-4 text-green-brand" /> Pix e recibo</h2>
      <p className="text-xs text-zinc-500">A chave aparece no PDF do orçamento e da OS (com QR Code Pix no valor total), na página do QR da OS e na variável {"{pix}"} das mensagens. Funciona sem Asaas. Deixe a chave vazia para não mostrar.</p>
      <div className="grid grid-cols-1 sm:grid-cols-[160px_1fr] gap-3">
        <div><Label className="text-[11px] text-zinc-400">Tipo da chave</Label>
          <select data-testid="pix-type" value={f.key_type} onChange={set("key_type")} className={`${selectCls} mt-1`}>{TYPES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}</select></div>
        <div><Label className="text-[11px] text-zinc-400">Chave Pix</Label><Input data-testid="pix-key" value={f.key} onChange={set("key")} className={cls} /></div>
        <div className="sm:col-span-2 grid grid-cols-1 sm:grid-cols-3 gap-3">
          <div><Label className="text-[11px] text-zinc-400">Nome do favorecido</Label><Input data-testid="pix-name" value={f.name} onChange={set("name")} className={cls} /></div>
          <div><Label className="text-[11px] text-zinc-400">Cidade</Label><Input data-testid="pix-city" value={f.city} onChange={set("city")} className={cls} /></div>
          <div><Label className="text-[11px] text-zinc-400">CPF/CNPJ (sai no recibo)</Label><Input data-testid="pix-doc" value={f.doc} onChange={set("doc")} className={cls} /></div>
        </div>
      </div>
      <Button data-testid="pix-save" onClick={save} disabled={busy} className="bg-green-brand text-white font-bold uppercase">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Salvar Pix"}</Button>
    </section>
  );
}
